module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-container"
  }, [_c('el-menu', {
    staticClass: "gradient",
    attrs: {
      "default-active": "1",
      "mode": "horizontal",
      "router": ""
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/white_logo.png")
    }
  }), _vm._v(" "), (!_vm.isDirectSurvey) ? _c('el-submenu', {
    staticClass: "item-right profile-image",
    attrs: {
      "index": ""
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/profile.png")
    }
  })]), _vm._v(" "), (!_vm.isAnonymousLogin && !_vm.isForRecruitment) ? _c('el-menu-item', {
    attrs: {
      "index": "/home/user/resetPassword"
    }
  }, [_vm._v("Reset Password")]) : _vm._e(), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/"
    }
  }, [_vm._v("Logout")])], 2) : _vm._e(), _vm._v(" "), (!_vm.isDirectSurvey && !_vm.isForRecruitment) ? _c('el-menu-item', {
    staticClass: "item-right",
    attrs: {
      "index": "/home"
    }
  }, [_vm._v("Home")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e6c74dbc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header/Header.vue
// module id = 503
// module chunks = 6